import React, { useEffect } from 'react'
import Aos from 'aos'
import 'aos/dist/aos.css'
import './signature.css'
import { Link } from 'react-router-dom'

// 引入圖示
import { HiOutlineLocationMarker } from 'react-icons/hi'

// 引入圖片資源
import img7 from '../../Assets/signImg/img7.jpeg'

// 行程資料
const Data = [
  {
    id: 7,
    imgSrc: img7,
    destTitle: '拆除隔閡 - 科學構建家庭親子關係',
    location: '🇺🇸 · 美國 · 新英格蘭',
    grade: 'K-12',
    fees: '6900 美元',
    description: '若父母殫精竭慮，孩子卻感受不到未來與希望，努力可能將走向反方向。來到全美教育理念最先進、資源最豐富、成果最卓越的新英格蘭，學習如何建立健康且有前景的親子關係。'
  },
]

export default function Signature7() {
  useEffect(() => {
    Aos.init({ duration: 2000 })
  }, [])

  return (
    <section className='signMain signContainer signSection'>
      <div className='signSecTitle'>
        <h3 data-aos='fade-right' className='signTitle'>
          拆 除 隔 閡 - 科 學 構 建 家 庭 親 子 關 係
        </h3>
        <button className='signHomeBtn'>
          <Link to='/' className='signHomeBtnLink'>返回首頁</Link>
        </button>
      </div>

      <div className='signSecContent signGrid'>
        {Data.map(({ id, imgSrc, destTitle, location, company, fees, description }) => (
          <div key={id} data-aos='fade-up' className='signSingleDestination'>
            <div className='signCardInfo'>
              <h4 className='signDestTitle'>{destTitle}</h4>
              <span className='signContinent signFlex'>
                <HiOutlineLocationMarker className='icon' />
                <span className='signName'>{location}</span>
              </span>

              <div className='signFees signFlex'>
                <div className='signGrade'>
                  <span>
                    執行機構：{company}
                    <br /><br />
                    <small>⭐️ 行 程 特 色 ⭐️</small>
                    <br /><br />
                  </span>
                </div>
                <div>
                  <p>{description}</p>
                  <table width='70%'>
                    <tbody>
                      <tr>
                        <td>活動內容</td>
                        <td></td>
                        <td>家庭互動工作坊、親子心理探索、戶外團隊活動、教育機構參訪</td>
                      </tr>
                      <tr>
                        <td>沉浸式體驗</td>
                        <td></td>
                        <td>透過親子共學與活動互動，深入了解彼此，建立正向溝通與信任</td>
                      </tr>
                      <tr>
                        <td>家長參與</td>
                        <td></td>
                        <td>全程親子同行，培養家庭凝聚力與支持系統</td>
                      </tr>
                      <tr>
                        <td>在地探索</td>
                        <td></td>
                        <td>參與美國在地教育、文化體驗與自然探索</td>
                      </tr>
                      <tr>
                        <td>未來規劃</td>
                        <td></td>
                        <td>透過活動引導家庭一同思考孩子成長方向與生涯藍圖</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='signFees signFlex'>
                <div className='signGrade'>
                  <span><small>⭐️ 參 團 資 訊 ⭐️</small></span>
                  <br /><br />
                </div>
                <table width='70%'>
                  <tbody>
                    <tr>
                      <td>招生對象</td>
                      <td></td>
                      <td>K-12 年齡層學生與其家庭成員</td>
                    </tr>
                    <tr>
                      <td>活動時間</td>
                      <td></td>
                      <td>2024 年 7 月</td>
                    </tr>
                    <tr>
                      <td>行程長度</td>
                      <td></td>
                      <td>14 天</td>
                    </tr>
                    <tr>
                      <td>活動地點</td>
                      <td></td>
                      <td>美國 · 新英格蘭地區</td>
                    </tr>
                    <tr>
                      <td>費用包含</td>
                      <td></td>
                      <td>活動課程、講師費、住宿、交通、親子活動材料、旅遊保險等</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className='signFees'>
                <div className='signGrade'>
                  <span><small>⭐️ 參 考 行 程 ⭐️</small></span>
                  <br /><br />
                </div>
                <p>實際活動內容可能會依天氣與場地做適度調整，出發前一週提供最終版本行程表。</p>
                <br />
                <table width='70%'>
                  <thead>
                    <tr>
                      <th width='20%'>日期</th>
                      <th width='30%'>上午活動</th>
                      <th width='50%'>下午活動</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>第一天</td>
                      <td>啟程</td>
                      <td>抵達後休息</td>
                    </tr>
                    <tr>
                      <td>第二天</td>
                      <td>迎新活動</td>
                      <td>親子溝通工作坊</td>
                    </tr>
                    <tr>
                      <td>第三天</td>
                      <td>情緒表達課程</td>
                      <td>戶外挑戰活動</td>
                    </tr>
                    <tr>
                      <td>第四天</td>
                      <td>參訪教育機構</td>
                      <td>文化交流晚會</td>
                    </tr>
                    <tr>
                      <td>第五天</td>
                      <td>自然探索</td>
                      <td>家庭反思時間</td>
                    </tr>
                    <tr>
                      <td>第六天</td>
                      <td>親子合作任務</td>
                      <td>學習總結與結業</td>
                    </tr>
                    <tr>
                      <td>第七天</td>
                      <td colSpan='2'>返回出發地</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className='signPrice'>
                <h5>預 售 價 格：{fees}</h5>
              </div>
              <button className='signBtn signFees'>
                <Link to='/formReg' target='_blank'>
                  <h4>⭐️ ⭐️ ⭐️ 預 約 報 名 - 搶 先 卡 位 ⭐️ ⭐️ ⭐️</h4>
                </Link>
              </button>
            </div>

            <div className='signImageDiv'>
              <img src={imgSrc} alt={destTitle} />
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
